import { render } from "./SFTypesView.vue?vue&type=template&id=5a294968"
import script from "./SFTypesView.vue?vue&type=script&lang=js"
export * from "./SFTypesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__